import { Component, OnInit } from '@angular/core';
import { AuthService, Errors, FooterService } from '../../../core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  errors: Errors = { errors: {} };
  maintenanceMessage;

  constructor(
    private footerService: FooterService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.getMaintenance();
  }
  /* fetch the  maintenance message */
  getMaintenance() {
    this.footerService.getMaintenanceMessage().subscribe((data) => {
      this.maintenanceMessage = data;
      if(data && !data.underMaintenance){
        window.location.href='/';
      }
    }, err => {
      this.errors = err;
    });
  }
  /* fetch the  maintenance message */

}
